import { Image } from '@cian/ui-kit';
import * as React from 'react';
import { Carousel } from 'react-responsive-carousel';

import * as styles from './FullscreenGalleryContent.css';
import './carousel.css';

interface IFullscreenGalleryContentProps {
  slides: { src: string; uid: string }[];
  currentSlide: number;
  onChange: (index: number, item: React.ReactNode) => void;
}

export const FullscreenGalleryContent: React.FC<IFullscreenGalleryContentProps> = ({
  slides,
  currentSlide,
  onChange,
}) => {
  return (
    <div>
      {/* @ts-ignore */}
      <Carousel
        showArrows
        useKeyboardArrows
        swipeable
        showThumbs={false}
        showStatus={false}
        showIndicators={false}
        selectedItem={currentSlide}
        onChange={onChange}
        autoFocus
      >
        {slides.map(({ src, uid }) => (
          <div key={uid} className={styles['image_block']} data-testid="FullscreenGalleryContent" data-uid={uid}>
            <Image src={src} alt="Фотография" borderRadius={0} objectFit="contain" theme="dark" />
          </div>
        ))}
      </Carousel>
    </div>
  );
};
